"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./Index.css");
const mithril_1 = __importDefault(require("mithril"));
const stream_1 = __importDefault(require("mithril/stream"));
// import StoredStream from '../StoredStream';
const geom_1 = require("../geom");
// import { Drag } from '../Drag';
// import _ from 'lodash';
const PIXI = __importStar(require("pixi.js"));
// import classNames from 'classnames';
const hammerjs_1 = __importDefault(require("hammerjs"));
function clamp(x, min, max) {
    return Math.min(Math.max(x, min), max);
}
function tilesEqual(tile1, tile2) {
    return tile1.x === tile2.x && tile1.y === tile2.y && tile1.z === tile2.z;
}
const r = window.devicePixelRatio > 1 ? '@2x' : '';
function tileUrl({ x, y, z }) {
    return `http://basemaps.cartocdn.com/rastertiles/voyager/${z}/${x}/${y}${r}.png`;
}
function tileIsBetterMatch(xy0, z, oldTile, newTile) {
    // can improve this later
    // for now: if both include pt, do zoom match
    // otherwise, do closest center
    const newContains = tileContainsXY0(newTile, xy0);
    const oldContains = tileContainsXY0(oldTile, xy0);
    if (newContains) {
        if (oldContains) {
            return Math.abs(newTile.z - (z + 0.5)) < Math.abs(oldTile.z - (z + 0.5));
        }
        else {
            return true;
        }
    }
    else {
        if (oldContains) {
            return false;
        }
        else {
            return geom_1.Point.quadrance(tileCenterXY0(newTile), xy0) < geom_1.Point.quadrance(tileCenterXY0(oldTile), xy0);
        }
    }
}
function latLngDegToXY0(latLng) {
    const [lat, lng] = latLng;
    const latRad = lat / 180 * Math.PI;
    return [
        (lng + 180) / 360,
        (1 - Math.log(Math.tan(latRad) + 1 / Math.cos(latRad)) / Math.PI) / 2,
    ];
}
function xy0ToXYN(xy0, z) {
    const s = Math.pow(2, z);
    return [xy0[0] * s, xy0[1] * s];
}
function xy0ToTile(xy0, z) {
    const xyN = xy0ToXYN(xy0, z);
    const [x, y] = [
        clamp(Math.floor(xyN[0]), 0, Math.pow(2, z) - 1),
        clamp(Math.floor(xyN[1]), 0, Math.pow(2, z) - 1),
    ];
    return { x, y, z };
}
function tileTopLeftXY0(tile) {
    return xyNToXY0([tile.x, tile.y], tile.z);
}
function tileCenterXY0(tile) {
    return xyNToXY0([tile.x + 0.5, tile.y + 0.5], tile.z);
}
function xyNToXY0(xyN, z) {
    const s = Math.pow(2, z);
    return [xyN[0] / s, xyN[1] / s];
}
function tileContainsXY0(tile, xy0) {
    const xy0Tile = xy0ToTile(xy0, tile.z);
    return tilesEqual(xy0Tile, tile);
}
// function z0toZN()
PIXI.utils.skipHello();
// PIXI.settings.SCALE_MODE = PIXI.SCALE_MODES.NEAREST;
const colorMapFrag = `
varying vec2 vTextureCoord;

uniform sampler2D uSampler;

void main(void){
  // Remember: input & output are premultiplied!
  vec4 orig = texture2D(uSampler, vTextureCoord);
  vec4 next = texture2D(uSampler, vTextureCoord + vec2(0.0, 0.01));
  // gl_FragColor = vec4(orig.y, orig.x, orig.z, orig.w);
  // gl_FragColor = vec4(0.5 * vec3(orig + next), 1.0);
  gl_FragColor = orig;
}
`;
function toPIXIMatrix(m) {
    return new PIXI.Matrix(m.a, m.b, m.c, m.d, m.e, m.f);
}
function onSpriteLoad(sprite, ready) {
    if (!sprite.texture.baseTexture.valid) {
        sprite.texture.baseTexture.on('loaded', ready);
    }
    else {
        ready();
    }
}
const Index = () => {
    let touchScreen = false;
    window.addEventListener('touchstart', () => touchScreen = true);
    // const view$ = StoredStream<View>('slippery:view', {
    //   center: [-122.436667, 37.753333],
    //   zoom: 10,
    // });
    let windowSize$ = stream_1.default([window.innerWidth, window.innerHeight]);
    const initialZ = 0;
    const [initialX, initialY] = [0.5, 0.5];
    // The transform matrix turns "local" points (xy0) into view points (pixels).
    // Suppose we're at zoom level 0. That means the entire world should be shown in 256 pixels.
    //   Entire world means, going from 0 to 1. So the scale should be 256.
    // Suppose were at zoom level 1. That means the entire world should be shown in 512 pixels.
    //   So multiply by 2! Etc.
    // (What coordinates are transform.e / transform.f in? Well, they're added to the final output, so they're in pixels!)
    let transform$ = stream_1.default(geom_1.Matrix.seq(geom_1.Matrix.translate(-initialX, -initialY), geom_1.Matrix.scale(Math.pow(2, initialZ) * 256), geom_1.Matrix.translate(windowSize$()[0] / 2, windowSize$()[1] / 2)));
    let z$ = transform$.map((transform) => Math.log(transform.a / 256) / Math.log(2));
    let mousePosScreen$ = stream_1.default([0, 0]);
    windowSize$.map((windowSize) => mousePosScreen$(geom_1.Point.mul(windowSize, 0.5)));
    let mouseXY0$ = stream_1.default.lift((mousePosScreen, transform) => transform.toLocal(mousePosScreen), mousePosScreen$, transform$);
    function oncreateMap(vnode) {
        let canvas = vnode.dom;
        let renderer = new PIXI.Renderer({ view: canvas, resolution: window.devicePixelRatio });
        windowSize$.map((windowSize) => renderer.resize(...windowSize));
        renderer.backgroundColor = 0x000000;
        let stage = new PIXI.Container();
        let container = new PIXI.Container();
        stage.addChild(container);
        // let sprite = PIXI.Sprite.from("https://deelay.me/1000/https://picsum.photos/200/300");
        // ok here's the logic:
        // at any given time, you have a displayed sprite and an ideal zoom.
        // once a sprite loads, it checks: am I closer to the ideal zoom than the displayed sprite?
        //   if so, destroy the displayed sprite and display me!
        //   otherwise, destroy me!
        // a URL is active if it is being loaded or being displayed
        // (there will only ever be at most one sprite extant for each active url)
        let activeUrls = {};
        let displayed;
        let spriteCount = 0;
        stream_1.default.lift((mouseXY0, z) => {
            const zTile = clamp(Math.ceil(z), 0, 30);
            const tile = xy0ToTile(mouseXY0, zTile);
            const url = tileUrl(tile);
            if (!activeUrls[url]) {
                activeUrls[url] = true;
                const sprite = PIXI.Sprite.from(url);
                spriteCount++;
                sprite.visible = false;
                sprite.width = 1 / (Math.pow(2, zTile));
                sprite.height = 1 / (Math.pow(2, zTile));
                const [tileXY0x, tileXY0y] = tileTopLeftXY0(tile);
                sprite.x = tileXY0x;
                sprite.y = tileXY0y;
                container.addChild(sprite);
                onSpriteLoad(sprite, () => {
                    if (!displayed || tileIsBetterMatch(mouseXY0$(), z$(), displayed.tile, tile)) {
                        // we're the winner!
                        if (displayed) {
                            delete activeUrls[displayed.url];
                            displayed.sprite.destroy({ texture: true, baseTexture: true });
                            spriteCount--;
                        }
                        displayed = { sprite, tile, url };
                        sprite.visible = true;
                    }
                    else {
                        delete activeUrls[url];
                        sprite.destroy({ texture: true, baseTexture: true });
                        spriteCount--;
                    }
                    renderer.render(stage);
                    // console.log('sprites', spriteCount, Object.keys(activeUrls).length);
                });
            }
        }, mouseXY0$, z$);
        // let graphics = new PIXI.Graphics();
        // graphics.lineTextureStyle({width: 0.01, color: 0x888888, alpha: 1, join: PIXI.LINE_JOIN.MITER, alignment: 0.5});
        // graphics.moveTo(0, 0);
        // graphics.lineTo(0, 1);
        // graphics.lineTo(1, 1);
        // graphics.lineTo(1, 0);
        // graphics.closePath();
        // container.addChild(graphics);
        // const colorMapFilter = new PIXI.Filter(undefined, colorMapFrag);
        // colorMapFilter.resolution = 2;
        // stage.filters = [ colorMapFilter ];
        const text = new PIXI.Text('One Tile At A Time', {
            fontFamily: 'Arial',
            fontSize: 24,
            align: 'left',
            fill: 0xF8F8F8,
            stroke: 0x222222,
            strokeThickness: 2,
        });
        text.position.x = 20;
        text.position.y = 20;
        stage.addChild(text);
        renderer.render(stage);
        stream_1.default.lift((transform, z, mousePosZ0) => {
            container.transform.setFromMatrix(toPIXIMatrix(transform));
            // text.text = `${z.toFixed(2)} ${mousePosZ0[0].toFixed(2)} ${mousePosZ0[1].toFixed(2)}`;
            renderer.render(stage);
        }, transform$, z$, mouseXY0$);
        // const loop = () => {
        //   const t = +new Date();
        //   container.setTransform(0, 10 * Math.sin(t / 1000));
        //   renderer.render(stage);
        //   requestAnimationFrame(loop);
        // };
        // loop();
        const hammer = new hammerjs_1.default.Manager(vnode.dom);
        hammer.add(new hammerjs_1.default.Pan());
        hammer.add(new hammerjs_1.default.Pinch());
        {
            let lastDeltaX;
            let lastDeltaY;
            hammer.on('panstart', () => {
                lastDeltaX = 0;
                lastDeltaY = 0;
            });
            hammer.on('pan', (e) => {
                // console.log(e.deltaX, e.deltaY);
                transform$(geom_1.Matrix.seq(transform$(), geom_1.Matrix.translate(e.deltaX - lastDeltaX, e.deltaY - lastDeltaY)));
                lastDeltaX = e.deltaX;
                lastDeltaY = e.deltaY;
            });
        }
        {
            let lastScale;
            hammer.on('pinchstart', () => {
                lastScale = 1;
            });
            hammer.on('pinch', (e) => {
                const mousePx = [e.center.x, e.center.y];
                const deltaScale = e.scale / lastScale;
                const scale = Math.max(deltaScale, Math.pow(2, -z$()) / 2);
                transform$(geom_1.Matrix.seq(transform$(), geom_1.Matrix.scale(scale).atPoint(mousePx)));
                lastScale = e.scale;
            });
        }
    }
    function onmousedownMap(event) {
        // (new Drag({
        //   onMove: function () {
        //     transform$(Matrix.seq(
        //       transform$(),
        //       Matrix.translate(...this.dPx)
        //     ));
        //   },
        // })).start(event);
    }
    function onmousemoveMap(event) {
        mousePosScreen$([event.clientX, event.clientY]);
    }
    function onwheelMap(ev) {
        const mousePx = [ev.clientX, ev.clientY];
        const scale = Math.max(Math.exp(-ev.deltaY / 300), Math.pow(2, -z$()) / 2);
        transform$(geom_1.Matrix.seq(transform$(), geom_1.Matrix.scale(scale).atPoint(mousePx)));
        ev.preventDefault();
    }
    function onresize() {
        windowSize$([window.innerWidth, window.innerHeight]);
    }
    return {
        oncreate() {
            window.addEventListener('resize', onresize);
        },
        onremove() {
            window.removeEventListener('resize', onresize);
        },
        view: () => {
            return mithril_1.default('.Index', mithril_1.default('canvas.Index-map', {
                oncreate: oncreateMap, onmousedown: onmousedownMap, onmousemove: onmousemoveMap, onwheel: onwheelMap,
                style: {
                    width: '100%', height: '100%',
                },
            }));
        },
    };
};
exports.default = Index;
